<template>
    <div class="mcomarall">
        <Header :header="header"></Header>   
        <!--依照套用參數進入樣板-->
        <component :is="currentComponent" v-model="querylist"></component >     
    </div>
</template>
<script>
//標頭
import Header from '../../components/admin/NavBar/Header.vue';

export default{
    components:{
        Header
    },
    data(){
        return{
            //標頭
            header:{
                text1:"首頁管理",
                text2:"輪播管理",
                text3:"內容編輯",
            },
            //樣式名稱
            currentComponent:null,
            //頁面參數
            querylist:{
                id:"",

            },

            //API
            //廣告橫版
            apiBanner: (data) => this.userRequest.post("bicd/Banner", data),
        }
    },
    props:[],
    mounted(){
        this.querylist = this.$route.query;
        this.querylist.typeId = this.$route.query.PJID.substring(8,this.$route.query.PJID.length);
        if(!this.$route.query.lang){
            this.querylist.lang="1";
        }

        //初始化
        this.init();
    },
    watch:{
        "$route.query"(){
            this.querylist = this.$route.query;
            this.querylist.typeId = this.$route.query.PJID.substring(8,this.$route.query.PJID.length);
            if(!this.$route.query.lang){
                this.querylist.lang="1";
            }
            this.createView();
        }
    },
    methods:{
        //初始化
        init(){
        },
        //切換內容畫面
        async createView(){
            //取得網址的樣式名稱，並進行動態轉換，以減少讀取時間
            switch(this.$route.query.modal){
                //單一頁面
                case "1":
                    //切換樣式，並匯入必要參數
                    break;
                //列表頁面
                case "2":
                    //切換樣式，並匯入必要參數
                    this.currentComponent = (await import('../../components/admin/Content/Banner/List.vue')).default;
                    break;
                //內容頁面
                case "3":
                    //切換樣式，並匯入必要參數
                    this.currentComponent = (await import('../../components/admin/Content/Banner/Content.vue')).default;
                    break;
                //從資料庫取得樣式
                case undefined:
                    //TODO 動態讀取頁面功能
                    break;
            }
        }
    },
    async created(){
        this.createView();
    }
}
</script>